/**
 * Internal dependencies
 */
import { getEditedLayout } from "state/dashboard-layouts/selectors";
import { v4 as uuidv4 } from "uuid";
import { getReport } from "state/reports/selectors";
import editLayout from "./edit-layout";

export default (layoutId, widgetId) => (dispatch, getState) => {
  const layout = getEditedLayout(getState(), layoutId);
  const widget = getReport(getState(), widgetId);

  if (!layout || !widget) {
    return null;
  }

  const updated = {
    items: [
      ...layout.items,
      {
        id: undefined,
        localId: uuidv4(),
        widgetId: widgetId,
        widget_type: widget.type_code,
        position: {
          w: 12,
          h: 8,
          x: (layout.items.length * 12) % 24,
          y: Infinity,
        },
      },
    ],
  };

  dispatch(editLayout(layoutId, updated));
};
